import { useState, useEffect } from 'react';

import * as yup from 'yup';

export const useValidPractice = (initialValue: string | null) => {
  const [practice, setPractice] = useState(initialValue);
  const [invalidPracticeMessage, setInvalidPracticeMessage] = useState('');

  useEffect(() => {
    const practiceSchema = yup.object().shape({
      practice: yup
        .string()
        .min(1)
        .required()
        .matches(/^[a-zA-Z' ]+$/, 'Only alphabets and apostrophes are allowed'),
    });

    if (practice !== null) {
      if (practice.length === 0) {
        setInvalidPracticeMessage('The practice name is required');
        return;
      }
    } else {
      setInvalidPracticeMessage('');
      return;
    }

    const isValid = practiceSchema.isValidSync({ practice });
    if (!isValid) {
      setInvalidPracticeMessage('Only alphabets and apostrophes are allowed');
      return;
    }

    setInvalidPracticeMessage('');
  }, [practice]);

  return { practice, setPractice, invalidPracticeMessage };
};
